import { css } from 'styled-components';

export const hideScrollbar = css`
	-ms-overflow-style: none; /* for Internet Explorer, Edge */
	scrollbar-width: none; /* for Firefox */
	&::-webkit-scrollbar {
		display: none; /* for Chrome, Safari, and Opera */
	}
`;
